<script setup>
const props = defineProps({
    speaker: {
        type: Object,
        required: true,
    },
    hero: {
        type: Boolean,
        default: false,
    },
})
</script>
<template>
    <div class='speaker-detail'>
        <SpeakersHeader :speaker="speaker" :hero=hero :key="speaker.id"  />
        <SpeakersSessions :sessions="speaker.sessions" :hero=hero v-if="speaker.sessions?.length" :key="speaker.id" />
    </div>
</template>